import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'database-item',
    template: require('./database-item.component.html'),
    styles: [require('./database-item.component.scss')]
})
export class DatabaseItemComponent {
    @Input() public item: any;
    @Output() public onClick = new EventEmitter<any>();
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/environment-databases/database-item/database-item.component.ts